import { render, staticRenderFns } from "./HorseGender.vue?vue&type=template&id=3710db4e&"
import script from "./HorseGender.vue?vue&type=script&lang=js&"
export * from "./HorseGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports